export default {
  recipeFinished: 'Postup už nebeží. Vaše zmeny nie je možné uložiť.',
  loadStarted: 'Počas vašich úprav bola spustená vsádzka. Žiadané hodnoty pece je možné meniť iba vtedy, keď nebeží žiadna vsádzka.',
  otherRecipeRunning: 'Teraz beží iná vsádzka alebo iný postup. Vaše zmeny nie je možné uložiť.',
  passedStepNotSaved: 'Zmeny v {step} sa neuložia, pretože krok už prebehol.',
};
